import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export default () => {
  const { accountOwnerId: multiPracticeAccountOwnerId } = useSelector(state => state.multiPracticeReducer.context)
  const { id: currentPracticeAccountOwnerId } = useSelector(state => state.practiceReducer.accountOwner)

  const accountOwnerId = useMemo(
    () => multiPracticeAccountOwnerId || currentPracticeAccountOwnerId,
    [multiPracticeAccountOwnerId, currentPracticeAccountOwnerId]
  )

  return accountOwnerId
}
